module.exports = __webpack_public_path__ + "img/confused_n.21e03836.png";